import { useEffect } from 'react';

function getIosVersion() {
    const ver = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);

    if (!ver) return '';
    return [parseInt(ver[1], 10), parseInt(ver[2], 10), parseInt(ver[3] || '0', 10)];
}

// images/-/moxie/new/js/components/platform-definition.js
export default function useBodyOSClasses() {
    useEffect(() => {
        const html = document.documentElement;
        const ua = global.navigator.userAgent;

        const iPad = !!ua.match(/(iPad).*OS\s([\d_]+)/);
        const iPhone = !iPad && !!ua.match(/(iPhone\sOS)\s([\d_]+)/);
        const iosVersion = getIosVersion();

        if (iPad || iPhone) {
            html.classList.add('ios');

            if (iosVersion && iosVersion[0] < 14) {
                html.classList.add('old-ios');
            }
        }

        if (!!ua.match(/(Android)\s+([\d.]+)/) || !!ua.match(/Silk-Accelerated/)) {
            html.classList.add('android');
        }

        if (
            /MSIE 9/i.test(global.navigator.userAgent) ||
            /rv:11.0/i.test(global.navigator.userAgent)
        ) {
            document.body.classList.add('ie11');
        }

        if (/Edge\/\d./i.test(global.navigator.userAgent)) {
            document.body.classList.add('edge');
        }
    }, []);

    return null;
}
